import React, { useEffect, useState } from "react";
import styles from "../Top/Top.module.css";
import design_icon from "../../assets/images/icons/design_icon.svg";
import shopping_bag_icon from "../../assets/images/icons/shopping_bag_icon.png";
import TopSingleCard from "./TopSingleCard";
import gallery_icon from "../../assets/images/icons/gallery_ace.svg";
import Faqline from "../../assets/images/Faqline.png";
import Faqlineqr from "../../assets/images/Faqlineqr.jpg";
import SidebarComponent from "../Reusables/SidebarComponent";

import { useNavigate } from "react-router-dom";
import useAxios from "../Hooks/useAxios";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import { linkProfile } from "../../constants";
const Top = () => {
  const navigate = useNavigate();
  const axios = useAxios();
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const [notifications, setNotifications] = useState({
    gallery: false,
    design: false,
    onlineshop: false,
  });
  useEffect(() => {
    axios
      .get(backend_base + "/user/my-page")
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Success Getting Cart Count Items");
          console.log(res.data);
          setNotifications(res.data);
        } else {
          console.log("Failed");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);
  return (
    <div>
      <Header />
      <div className={`${styles.top}`}>
        <SidebarComponent></SidebarComponent>
        <div className={styles.fill_div_spacing_01}></div>
        <div className={styles.second_column_div}>
          <div className={styles.second_column_div_heading}>マイページ</div>
          <div className={styles.second_column_all_card_section}>
            <div className={styles.second_column_all_cards_section_row}>
              <div
                onClick={() => {
                  navigate("/gallery-front");
                }}
              >
                <TopSingleCard
                  icon={gallery_icon}
                  headingText="Gallery"
                  description={[
                    "データのダウンロード",
                    "データ再購入・年間パス",
                  ]}
                  fontFamily="Futura Book PT"
                  fontSize="25px"
                  letterSpacing="2.5px"
                  fontWeight="600"
                  iconWidth="31px"
                  iconHeight="25px"
                  warning={notifications.gallery}
                ></TopSingleCard>
              </div>
              <div
                onClick={() => {
                  navigate("/visit-registration");
                }}
              >
                <TopSingleCard
                  headingText="来店時のご登録"
                  description={["スタジオでスタッフと一緒に", "ご登録ください"]}
                ></TopSingleCard>
              </div>
            </div>
            <div className={styles.second_column_all_cards_section_row}>
              <div
                onClick={() => {
                  navigate("/design-box");
                }}
              >
                <TopSingleCard
                  icon={design_icon}
                  headingText="Design"
                  description={["アイテムの編集", "完成デザインの確認"]}
                  fontFamily="Futura Book PT"
                  fontSize="25px"
                  letterSpacing="5px"
                  fontWeight="600"
                  tag="サンプル確認あり"
                  warning={notifications.design}
                ></TopSingleCard>
              </div>
              <div
                onClick={() => {
                  navigate("/check-history/2");
                }}
              >
                <TopSingleCard
                  headingText="来店履歴・購入履歴"
                  description={["履歴の確認"]}
                ></TopSingleCard>
              </div>
            </div>
            <div className={styles.second_column_all_cards_section_row}>
              <div
                onClick={() => {
                  navigate("/onlineshop");
                }}
              >
                <TopSingleCard
                  icon={shopping_bag_icon}
                  headingText="Onlineshop"
                  description={["アイテムの購入"]}
                  fontFamily="Futura Book PT"
                  fontSize="25px"
                  letterSpacing="5px"
                  fontWeight="600"
                  iconWidth="26px"
                  iconHeight="30px"
                ></TopSingleCard>
              </div>
              <div
                onClick={() => {
                  navigate("/annual-pass-contract-status");
                }}
              >
                <TopSingleCard
                  headingText="年間保管パス契約状況"
                  description={["年間保管パスの契約状況", "継続のお手続き"]}
                  tag="利用中"
                  warning={notifications.onlineshop}
                  bottomWarningText={
                    notifications.onlineshop
                      ? "年間保管パス期限　2023/01/10"
                      : ""
                  }
                ></TopSingleCard>
              </div>
            </div>
          </div>
          <div className={`${styles.line}`}>
            <div className={styles.linehead}>お問い合わせ</div>
            <div className={`${styles.lineinfo}`}>
              <div className="d-flex">
                <div className={`d-flex flex-column`}>
                  <a
                    href={linkProfile}
                    style={{ textDecoration: "none" }}
                    className={`d-flex ${styles.lineimgtxt}`}
                  >
                    <img src={Faqline} alt="" />
                    <h5 style={{ textDecoration: "none" }}>
                      LINE Official Account
                    </h5>
                  </a>
                  <div className={styles.lineDetails}>
                    商品に関するお問い合わせや編集のご質問は、Acestudio Official
                    LINEまで
                    <br />
                    お願いいたします。
                    <br />
                    QRコードを読み取り、お友達登録後メッセージを送信してください。
                  </div>
                </div>
                <div className={styles.qr}>
                  <img src={Faqlineqr} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Top;
